"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var acs_sc_web_platform_api_1 = require("@adsk/acs-sc-web-platform-api");
var loadSegment_1 = __importDefault(require("./loadSegment"));
var segmentApiKey_1 = __importDefault(require("./segmentApiKey"));
var env_1 = require("../env");
var MockAnalyticsStore_1 = __importDefault(require("../MockAnalyticsStore"));
var sanitizeTraits_1 = __importDefault(require("../sanitizeTraits"));
// Determine the project UID from the URL
var PROJECT_REGEX = /\/projects\/([\da-f]{8}-[\da-f]{4}-[\da-f]{4}-[\da-f]{4}-[\da-f]{12})/;
var REGION = (0, acs_sc_web_platform_api_1.getRegion)();
function getProjectUidFromWindowLocation() {
    var url = new URL(window.location.href);
    var match = PROJECT_REGEX.exec(url.pathname);
    if (match)
        return match[1];
    return null;
}
function addProjectUidToProperties(properties) {
    var projectUid = getProjectUidFromWindowLocation();
    var platform = (0, acs_sc_web_platform_api_1.getPlatformFromUrl)().replace('bim360', 'b360');
    return __assign(__assign({ user_type: platform, project_type: platform, data_center: REGION, screen_height: window.innerHeight, screen_width: window.innerWidth }, (projectUid && { project_id: projectUid })), properties);
}
var analytics = {
    _queuedEvents: [],
    _queuedIdentifies: [],
    _waitForBaseProperties: null,
    _isInitialized: function () { var _a; return !!((_a = window.analytics) === null || _a === void 0 ? void 0 : _a.initialized); },
    setBaseProperties: function (newProperties) {
        window.accAnalyticsBaseProperties = __assign(__assign({}, window.accAnalyticsBaseProperties), newProperties);
        if (env_1.NODE_ENV === 'development') {
            console.log('%c[analytics.setBaseProperties] %cprops=', 'color:cornflowerblue', 'color:slategrey', window.accAnalyticsBaseProperties);
        }
        analytics._tryToFlushQueues();
    },
    getBaseProperty: function (propertyName) {
        var _a;
        return (_a = window.accAnalyticsBaseProperties) === null || _a === void 0 ? void 0 : _a[propertyName];
    },
    waitForBaseProperties: function () {
        var propertyNames = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            propertyNames[_i] = arguments[_i];
        }
        analytics._waitForBaseProperties = propertyNames;
        if (env_1.NODE_ENV === 'development') {
            console.log('%c[analytics.waitForBaseProperties] %cprops=', 'color:cornflowerblue', 'color:slategrey', analytics._waitForBaseProperties);
        }
    },
    _tryToFlushQueues: function () {
        var _a;
        if (!analytics._isInitialized()) {
            return;
        }
        if ((_a = analytics._waitForBaseProperties) === null || _a === void 0 ? void 0 : _a.some(function (prop) {
            return !(window.accAnalyticsBaseProperties &&
                prop in window.accAnalyticsBaseProperties);
        })) {
            return;
        }
        analytics._waitForBaseProperties = null;
        for (var _i = 0, _b = analytics._queuedIdentifies; _i < _b.length; _i++) {
            var _c = _b[_i], userAnalyticsId = _c[0], traits = _c[1];
            analytics.identify(userAnalyticsId, traits);
        }
        analytics._queuedIdentifies = [];
        for (var _d = 0, _e = analytics._queuedEvents; _d < _e.length; _d++) {
            var _f = _e[_d], event_1 = _f[0], properties = _f[1];
            analytics.track(event_1, properties);
        }
        analytics._queuedEvents = [];
    },
    track: function (event, properties) {
        var _a;
        if (analytics._waitForBaseProperties ||
            !analytics._isInitialized() ||
            !((_a = window === null || window === void 0 ? void 0 : window.analytics) === null || _a === void 0 ? void 0 : _a.track)) {
            if (env_1.NODE_ENV === 'development') {
                console.log('%c[analytics.track%c[QUEUED - NOT SENT]%c] %cevent=%c' +
                    event +
                    ' %cprops=', 'color:cornflowerblue', 'color:red', 'color:cornflowerblue', 'color:slategrey', 'color:cornflowerblue;font-weight:600', 'color:slategrey', properties);
            }
            analytics._queuedEvents.push([event, properties]);
            return;
        }
        properties = addProjectUidToProperties(__assign(__assign({}, window.accAnalyticsBaseProperties), properties));
        if (env_1.NODE_ENV === 'production') {
            window.analytics.track(event, properties);
        }
        else if (env_1.NODE_ENV === 'test') {
            MockAnalyticsStore_1.default._recordTrack(event, properties);
        }
        else {
            console.log('%c[analytics.track] %cevent=%c' + event + ' %cprops=', 'color:cornflowerblue', 'color:slategrey', 'color:cornflowerblue;font-weight:600', 'color:slategrey', properties);
        }
    },
    identify: function (userAnalyticsId, traits) {
        var _a;
        if (!analytics._isInitialized() || !((_a = window === null || window === void 0 ? void 0 : window.analytics) === null || _a === void 0 ? void 0 : _a.identify)) {
            if (env_1.NODE_ENV === 'development') {
                console.log('%c[analytics.identify%c[QUEUED - NOT SENT]%c] %cuserAnalyticsId=%c' +
                    userAnalyticsId +
                    ' %ctraits=', 'color:cornflowerblue', 'color:red', 'color:cornflowerblue', 'color:slategrey', 'color:cornflowerblue;font-weight:600', 'color:slategrey', traits);
            }
            analytics._queuedIdentifies.push([userAnalyticsId, traits]);
            return;
        }
        var sanitizedTraits = (0, sanitizeTraits_1.default)(traits);
        if (env_1.NODE_ENV === 'production') {
            window.analytics.identify(userAnalyticsId, sanitizedTraits);
        }
        else if (env_1.NODE_ENV === 'test') {
            MockAnalyticsStore_1.default._recordIdentify(userAnalyticsId, sanitizedTraits);
        }
        else {
            if (sanitizedTraits)
                console.log('%c[analytics.identify] %cuserAnalyticsId=%c' +
                    userAnalyticsId +
                    ' %ctraits=', 'color:cornflowerblue', 'color:slategrey', 'color:cornflowerblue;font-weight:600', 'color:slategrey', sanitizedTraits);
            else
                console.log('%c[analytics.identify] %userAnalyticsId=%c' + userAnalyticsId, 'color:cornflowerblue', 'color:slategrey', 'color:cornflowerblue;font-weight:600');
        }
    },
    load: function () {
        if (env_1.NODE_ENV === 'test') {
            MockAnalyticsStore_1.default._recordLoad();
        }
        return new Promise(function (resolve) {
            (0, loadSegment_1.default)((0, segmentApiKey_1.default)(), function () {
                if (env_1.NODE_ENV === 'development') {
                    console.log('%c[analytics.load]', 'color:cornflowerblue');
                }
                if (env_1.NODE_ENV === 'test') {
                    // in production done by segment script
                    window.analytics = window.analytics || {};
                    window.analytics.initialized = true;
                }
                var event = new CustomEvent('alloyAnalyticsLoaded');
                window.dispatchEvent(event);
                resolve();
            });
        });
    },
};
window.addEventListener('alloyAnalyticsLoaded', function () {
    analytics._tryToFlushQueues();
}, { once: true });
if (!window.skipAlloyAnalyticsLoad) {
    void analytics.load();
}
exports.default = analytics;
